<style media="print" type="text/css">
@page {
  /*size: A4 portrait;*/
  margin: 15px
}

p {
  margin-bottom: 0px;
}



</style>


<template>
  <div style="">
    <!-- SOURCE -->
    <div class="">
      <div id="printMe">
        <v-row class="p-0">
          <v-col v-for="(values,i) in value_list" :key="values.shipment_id"
                 class="pa-0" md="6" style="margin-top: 0px">
            <div
                 style="padding-left: 6px; width: 345px; height: 235px; overflow: hidden; min-height: 235px;max-height: 235px; display: inline-block;vertical-align: top">
              <div style=" padding: 0px 10px 0px 0px;font-family: 'Nunito Sans', sans-serif;">
                <div style="border-bottom: solid 2px black; ">
                  <div style="display:table-cell;width:75px;border-right: solid 2px black;vertical-align: middle;">
                    <p style="font-size: 26px;font-family: 'Nunito Sans', sans-serif">MedX</p>
                  </div>
                  <div style="display:table-cell;padding-left:8px; vertical-align: top">
                    <span style="font-size: 10px">From: </span>
                  </div>
                  <div style="display:table-cell;padding-left:5px;">
                    <p style="font-weight: bold;font-size: 10px;">{{ values.wholesaler_name }}</p>
                    <p style="font-size: 10px;">{{ values.wholesaler_address }}</p>
                    <p style="font-size: 10px;">{{ values.wholesaler_phone_number }}</p>
                  </div>
                </div>

                <table style="width:100%;border-collapse:collapse; margin-bottom: 0px">
                  <tr style="border-bottom: solid 2px black">
                    <td colspan="3">
                      <p style="font-size: 8px">To : </p>
                      <p style="font-weight: bold; font-size: 10px;">{{ values.retailer_name }}</p>
                      <p style="font-size: 10px;">{{ values.retailer_address }}</p>
                      <p v-if="values.retailer_phone_number" style="font-size: 13px;">{{
                          values.retailer_phone_number
                        }}</p>
                    </td>
                    <td style="vertical-align: top; text-align: right; padding:0px 0px;">
                      <span style="color:black;font-size: 2.7rem;">{{ values.line }}</span>
                    </td>
                  </tr>
                </table>
                <table style="width:100%;border-collapse:collapse;margin-bottom: 0px;font-size: 10px;">
                  <tr style="border-bottom: solid 2px black;vertical-align: top;">
                    <td colspan="3" style="padding:4px 0px;">
                      <span style="font-weight: bold">Ch. /B. No.: {{ values.challan_number }} </span><br>
                      <span style="font-weight: bold">Amount: {{ values.amount }}</span>
                    </td>
                    <td style="text-align: right; padding:4px 0px 0px 0px;">
                      <p style="margin-top:0px; margin-bottom:5px; font-weight: bold ">Package
                        {{ values.current_package_count }}
                        of {{ values.package_count }}
                      </p>
                      <span style="font-weight: bolder; font-size: 12px;">{{ values.payment_mode }}</span>
                    </td>
                  </tr>
                </table>
                <table style="width:100%;border-collapse:collapse;">
                  <tr>
                    <td style="text-align: center;">
                      <img :src="values.barcode" style="width: 100%;height: 55px;"/>
                    </td>
                    <td><span
                        style="writing-mode: vertical-rl;font-weight: normal; font-size: 8px;margin-left: -24px">{{
                        values.id
                      }}</span>
                    </td>
                  </tr>
                </table>
                <div>
                </div>
                <p style="text-align: center; margin-top: -4px"><small>Time : {{ values.created }}
                </small>
                </p>
              </div>
            </div>
            <!--            <div v-if="(i+1)%4==0" style="height:0px; page-break-after: always"></div>-->

            <div v-if="(i+1)%4==0&& i==3" style="width: 335px; height:520px;page-break-after: always"></div>
<!--            <div v-if="(i+1)%4 ==0 && i==3" style="width: 335px; height:260px;"></div>-->

            <div v-if="(i+1)%4==0&& i==7" style="width: 335px; height:430px;page-break-after: always"></div>
<!--            <div v-if="(i+1)%4 ==0 && i==7" style="width: 335px; height:200px;"></div>-->

            <div v-if="(i+1)%4==0&& i==11" style="width: 335px; height:535px;page-break-after: always"></div>

            <div v-if="(i+1)%4==0&& i==15" style="width: 335px; height:595px;page-break-after: always"></div>
            <div v-if="(i+1)%4==0&& i>15" style="width: 335px; height:560px;page-break-after: always"></div>

          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value_list: [],
      shipment_ids: []
    }
  },
  created() {
    this.shipment_ids = this.$route.params.id
    this.getPdfData()
  },
  methods: {
    getPdfData() {
      // if (this.shipment_id_list.length == 0) {
      //   this.showSnakeBar("warning", this.$messages.NO_SHIPMENT_SELECTED);
      //   return false;
      // }
      const self = this;
      let params = {
        shipment_id_list: this.shipment_ids
      };
      this.$store.dispatch("setPageLoader", true);
      const successHandler = (response) => {
        if (response.data.success) {
          self.value_list = response.data.value_list.value_list
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
        // this.$htmlToPaper('printMe-' + this.shipment_id);
        // this.$htmlToPaper('printMe');
        print()
      };
      self.request_GET(
          self,
          this.$urls.BASE_URL + "shipment/get-bulk-pdf/",
          params,
          successHandler,
          null,
          null,
          finallyHandler
      )
      ;
    },
  }
}
</script>
